import React from "react"
import PropTypes from "prop-types"
class CardImage extends React.Component {
  render () {

    var imgClass = "price-card-image-image";
    if (this.props.htmlClass) {
      imgClass = this.props.htmlClass;
    }

    const variants = this.props.sourceImageVariants || {};
    const small = variants["265x370"];
    const large = variants["672x938"] || small;

    var srcset = "";
    var defaultSrc = "";

    if (small || large) {
      const entries = [];
      if (small) {
        entries.push(`${small} 1x`);
        defaultSrc = small;
      }
      if (large && large !== small) {
        entries.push(`${large} 2x`);
        defaultSrc = large;
      }
      srcset = entries.join(", ");
    } else if (this.props.imageUrl) {
      defaultSrc = this.props.imageUrl;
    }

    return (
      <React.Fragment>
        <picture>
          <span className="price-card-invisible-label">{this.props.cardName}</span>
          <source type="image/jpg" srcSet={srcset}/>
          <img className={imgClass} alt={this.props.cardName} src={defaultSrc}/>
        </picture>
      </React.Fragment>
    );
  }
}

CardImage.propTypes = {
  cardName: PropTypes.string,
  cardId: PropTypes.string,
  htmlClass: PropTypes.string,
  imageUrl: PropTypes.string,
  sourceImageVariants: PropTypes.object,
};
export default CardImage
